'use client';

import { FieldValues, UseFormReturn } from 'react-hook-form';

import { BillingFieldsEnum } from '@sola/schema/dotcom/checkout/billingInfo.ts';
import { SENSITIVE_MASK_CHAR } from '@sola/shared-utils/constants.ts';

export const validationKeys = {
  differentNumbers: 'differentNumbers',
};

/**
 * @description ACH account number and routing number are tied together in the token - changing one requires re-tokenizing and therefore both values need to be updated
 */
export const resetAchRoutingAndAccount = (
  formContext: UseFormReturn<FieldValues, unknown, unknown>,
) => {
  formContext.setValue(BillingFieldsEnum.ACHAccountNumber, null);
  formContext.setValue(BillingFieldsEnum.ACHRoutingNumber, null);
};

export const containsAlphaChars = (str: string) => /[a-zA-Z]/.test(str);
export const containsNonAlphaChars = (str: string) => /[^a-zA-Z]/.test(str);
export const containsNumericChars = (str: string) => /\d/.test(str);
export const containsNonNumericChars = (str: string) => /\D/.test(str);

export const shouldRemoveSpecialChars = (str: string) =>
  str && containsNonNumericChars(str) && str.indexOf(SENSITIVE_MASK_CHAR) < 0;
export const removeNonDigits = (str: string) => str.replace(/\D/g, '');
